import { render, staticRenderFns } from "./detalleProducto.vue?vue&type=template&id=3803a89c&scoped=true"
import script from "./detalleProducto.vue?vue&type=script&lang=js"
export * from "./detalleProducto.vue?vue&type=script&lang=js"
import style0 from "./detalleProducto.vue?vue&type=style&index=0&id=3803a89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803a89c",
  null
  
)

export default component.exports